import styled from 'styled-components';
import * as fonts from 'view/styles/fonts';
import * as grid from 'view/styles/grid';
import { portalsCardTitleStyle } from 'view/styles/help-center';
import { token } from '@atlaskit/tokens';
import { colors } from '@atlaskit/theme';

export const FilterWrapper = styled.div`
    width: ${grid.multiple(28).px};
    padding: ${token('space.200', '16px')};
    margin-left: ${token('space.negative.200', '-16px')};
`;

export const FilterContent = styled.div`
    display: flex;
    align-items: center;
    ${portalsCardTitleStyle}

    label {
        ${fonts.h300};
        text-transform: uppercase;
        margin: 0;
        color: ${token('color.text.subtlest', colors.N400)};
    }
`;
